import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const HIDE_ON_PREFIXES = ['/admin', '/master', '/chatbot', '/marketing', '/humanresources', '/hr'];

const WhatsAppButton = () => {
  const location = useLocation();
  const isInternalRoute = HIDE_ON_PREFIXES.some(p => location.pathname.startsWith(p));
  const [settings, setSettings] = useState(null);
  const [isPulsing, setIsPulsing] = useState(true);

  useEffect(() => {
    fetchSettings();
    const timer = setTimeout(() => setIsPulsing(false), 5000);
    return () => clearTimeout(timer);
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await axios.get(`${API}/settings`);
      setSettings(response.data);
    } catch (error) {
      console.error('Failed to fetch settings:', error);
    }
  };

  const handleWhatsAppClick = () => {
    if (settings) {
      const message = encodeURIComponent(settings.whatsapp_message);
      const url = `https://wa.me/${settings.whatsapp}?text=${message}`;
      window.open(url, '_blank');
    }
  };

  if (isInternalRoute) return null;
  if (!settings) return null;

  return (
    <button
      onClick={handleWhatsAppClick}
      className={`fixed p-3 rounded-full shadow-xl transition-all duration-300 hover:scale-110 active:scale-95 ${
        isPulsing ? 'animate-pulse' : ''
      }`}
      style={{ 
        backgroundColor: '#25D366',
        bottom: '60px',
        right: '20px',
        zIndex: 99999999,
        width: '56px',
        height: '56px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '3px solid white'
      }}
      data-testid="whatsapp-floating-btn"
      aria-label="Contact via WhatsApp"
    >
      <MessageCircle className="h-6 w-6 text-white" />
    </button>
  );
};

export default WhatsAppButton;